import type {IModel} from "../../data/models/Model";

export const getNewDetailedItems = (stateDetailedItems: {model: IModel; isMainBlurred: boolean}[], item: {model: IModel; isMainBlurred: boolean}) => {
	// const indexOfItem = stateDetailedItems.indexOf(item);

	// return indexOfItem > -1 ? [...stateDetailedItems].slice(0, indexOfItem) : [...stateDetailedItems, item];

	return [...stateDetailedItems, item];
};

export const onDetailsContainerClose = (cmp: {overlayedDetailedItems: {model: IModel; isMainBlurred: boolean}[]}, closeAll: boolean = false) => {
	if (cmp.overlayedDetailedItems.length > 0) {
		if (closeAll) {
			cmp.overlayedDetailedItems = [];
		} else {
			const newOverlayedDetailedItems = [...cmp.overlayedDetailedItems];

			newOverlayedDetailedItems.pop();

			cmp.overlayedDetailedItems = newOverlayedDetailedItems;
		}
	}
};
